<template>
  <div id="app" class="home-view">
    <!-- 二次确认弹框 -->
    <logoutDialog
      v-if="isShowLogoutDialog"
      @logout="logOutLogin"
      @close="isShowLogoutDialog = false"
    ></logoutDialog>
    <div class="clearfix">
      <div class="title_top clearfix" v-if="ispc">
        <div class="logo">
          <img
            src="./assets/images/title1.png"
            alt=""
            v-if="select !== 'about'"
          />
          <img
            src="./assets/images/title2.png"
            alt=""
            v-if="select === 'about'"
          />
        </div>
        <m-tabbar v-model="select">
          <m-tabbar-item id="home" isRouter>
            <img
              src="./assets/images/Font_homeB@2x.png"
              alt=""
              slot="icon-normal"
              v-if="select !== 'about'"
            />
            <img
              src="./assets/images/Font_homeW@2x.png"
              slot="icon-normal"
              v-if="select === 'about'"
            />
            <img
              src="./assets/images/Font_homeB@2x.png"
              alt=""
              slot="icon-active"
            />
            <span
              class="item-text"
              :style="[
                { backgroundColor: select === 'about' ? '#363C47' : '' },
                { width: select === 'home' ? '52px' : '' },
              ]"
            ></span>
          </m-tabbar-item>
          <m-tabbar-item id="about" isRouter>
            <img
              src="./assets/images/Font_aboutB@2x.png"
              alt=""
              slot="icon-normal"
            />
            <img
              src="./assets/images/Font_aboutY@2x.png"
              alt=""
              slot="icon-active"
            />
          </m-tabbar-item>
          <!-- <m-tabbar-item id="group" isRouter>
          <img
            src="./assets/images/Font_teamB@2x.png"
            alt=""
            slot="icon-normal"
            v-if="select !== 'about'"
          />
          <img
            src="./assets/images/Font_teamW@2x.png"
            alt=""
            slot="icon-normal"
            v-else
          />
          <img
            src="./assets/images/Font_teamB@2x.png"
            alt=""
            slot="icon-active"
          />
        </m-tabbar-item> -->
         <m-tabbar-item id="series" isRouter>
            <img
              src="./assets/images/bqbb.png"
              alt=""
              slot="icon-normal"
              v-if="select !== 'about'"
            />
            <img
              src="./assets/images/bqbb.png"
              alt=""
              slot="icon-normal"
              v-else
            />
            <img src="./assets/images/bqbw.png" alt="" slot="icon-active" />
          </m-tabbar-item>
          <m-tabbar-item id="product" isRouter>
            <img
              src="./assets/images/Font_proB@2x.png"
              alt=""
              slot="icon-normal"
              v-if="select !== 'about'"
            />
            <img
              src="./assets/images/Font_proW@2x.png"
              alt=""
              slot="icon-normal"
              v-else
            />
            <img
              src="./assets/images/Font_proB@2x.png"
              alt=""
              slot="icon-active"
            />
          </m-tabbar-item>
          <m-tabbar-item id="recruit" isRouter>
            <img
              src="./assets/images/Font_recB@2x.png"
              alt=""
              slot="icon-normal"
              v-if="select !== 'about'"
            />
            <img
              src="./assets/images/Font_recW@2x.png"
              alt=""
              slot="icon-normal"
              v-else
            />
            <img
              src="./assets/images/Font_recB@2x.png"
              alt=""
              slot="icon-active"
            />
          </m-tabbar-item>

        </m-tabbar>
        <div class="title_hei"></div>
      </div>
      <div class="dot_box" v-if="ispc">
        <router-link
          tag="li"
          to="/home"
          :class="path == '/about' ? 'about_dot' : ''"
          active-class="home_click"
        >
          <span class="dot"></span>
        </router-link>
        <router-link
          tag="li"
          to="/about"
          :class="path == '/about' ? 'about_dot' : ''"
          :active-class="path == '/about' ? 'about_click' : 'home_click'"
        >
          <span class="dot"></span>
        </router-link>
         <router-link
          tag="li"
          to="/series"
          :class="path == '/series' ? 'about_dot' : ''"
          active-class="home_click"
        >
          <span class="dot"></span>
        </router-link>
        <!-- <router-link
        tag="li"
        to="/group"
        :class="path == '/about' ? 'about_dot' : ''"
        active-class="home_click"
      >
        <span class="dot"></span>
      </router-link> -->
        <router-link
          tag="li"
          to="/product"
          :class="path == '/about' ? 'about_dot' : ''"
          active-class="home_click"
        >
          <span class="dot"></span>
        </router-link>

        <router-link
          tag="li"
          to="/recruit"
          :class="path == '/about' ? 'about_dot' : ''"
          active-class="home_click"
        >
          <span class="dot"></span>
        </router-link>
        <!-- <router-link
          tag="li"
          to="/post"
          :class="path == '/about' ? 'about_dot' : ''"
          active-class="home_click"
        >
          <span class="dot"></span>
        </router-link> -->

      </div>
      <m-message class="myMessage" v-if="ispc"></m-message>
      <transition name="component-fade" mode="out-in" v-if="ispc">
        <router-view></router-view>
      </transition>
      <!--  -->
      <div class="isapp" v-if="!ispc">
        <m-apphome></m-apphome>
      </div>
    </div>
    <!-- 个人中心按钮 -->
    <div class="top-head">
      <div v-if="loginsucess" @click="goToPersonPage" class="user-info">
        欢迎您{{ name }}
      </div>
      <button
        v-if="!loginsucess"
        :class="['login-button', 'blue']"
        @click="logOut(loginsucess)"
      >
        登录
      </button>
      <button
        v-if="loginsucess"
        :class="['logout-button', 'red']"
        @click="logOut(loginsucess)"
      >
        退出
      </button>
    </div>
  </div>
</template>
<script>
import mTabbar from './components/tabbar'
import mTabbarItem from './components/tabbar-item'
import mMessage from './components/bottom-message'
import mApphome from './components/apphome'
import logoutDialog from './components/logout-dialog'
import api from './servies/api'
import { EventBus } from '@/eventBus' // 导入全局事件总线

let Timeout
export default {
  name: 'app',
  components: {
    mTabbar,
    mTabbarItem,
    mMessage,
    mApphome,
    logoutDialog
  },
  data () {
    return {
      name: '', // 用户名
      userphone: '', // 手机号
      orderList: [], // 订单列表
      isShowDetail: true,
      isShowLogoutDialog: false, // 是否显示退出二次确认弹框
      select: '',
      path: '',
      path_post: false,
      ispc: false,
      loginsucess: false
    }
  },

  created () {
    EventBus.$on('update-message', this.updateMessage) // 监听事件
    this.select = this.$route.path.split('/')[1]
    EventBus.$on('cancel', this.cancel) // 监听事件
  },
  beforeDestroy () {
    EventBus.$off('cancel', this.cancel) // 移除事件监听

    EventBus.$off('update-message', this.updateMessage) // 移除事件监听
  },

  mounted () {
    let _this = this
    if (!_this.isMobile()) {
      _this.ispc = true
      // if (document.addEventListener) {
      //   document.addEventListener('DOMMouseScroll', TimeoutSet)
      // }// 兼容火狐
      // document.onmousewheel = TimeoutSet// 其他浏览器
    } else {
      _this.ispc = false
    }
    function TimeoutSet (e) {
      console.log(window.innerWidth)
      // if(document.body.offsetWidt<850){
      // }
      if (_this.isMobile()) {
        console.log(1)
        return false
      } else {
        console.log(2)
      }
      if (Timeout) clearTimeout(Timeout)
      var callNow = !Timeout
      Timeout = setTimeout(function () {
        Timeout = null
      }, 100)
      if (callNow) myWheel(e)
    }
    function myWheel (e) {
      if (e.wheelDelta > 0) {
        // 兼容IE,Opera,Chrome
        switch (_this.path_post || _this.select) {
          case 'about':
            _this.$router.replace('home')
            break
          case 'group':
            _this.$router.replace('about')
            break
          case 'product':
            _this.$router.replace('group')
            break
          case 'recruit':
            _this.$router.replace('product')
            break
          case 'series':
            _this.$router.replace('series')
            break
          case _this.path_post || _this.select:
            _this.$router.replace('recruit')
            _this.path_post = false
            break
        }
      } else if (e.detail > 0) {
        // 兼容Firefox
        switch (_this.select) {
          case 'about':
            _this.$router.replace('home')
            break
          case 'group':
            _this.$router.replace('about')
            break
          case 'product':
            _this.$router.replace('group')
            break
          case 'recruit':
            _this.$router.replace('product')
            break
          case 'series':
            _this.$router.replace('series')
            break
        }
      } else {
        switch (_this.select) {
          case 'home':
            _this.$router.replace('about')
            break
          case 'about':
            _this.$router.replace('group')
            break
          case 'group':
            _this.$router.replace('product')
            break
          case 'product':
            _this.$router.replace('recruit')
            break
          case 'series':
            _this.$router.replace('series')
            break
          case 'recruit':
            _this.$router.replace('post')
            break
        }
      }
    }
    // 验证cookie
    this.checkCookie()

    // 读取本地存储name
    this.name = localStorage.getItem('name')
  },

  methods: {
    cancel () {
      document.cookie =
        'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      this.loginsucess = false
    },
    updateMessage (name) {
      this.name = name
      this.loginsucess = true
    },

    updateName (name) {
      this.name = name
    },
    logOutLogin () {
      api.logout({}).then((res) => {
        console.log('logOutLogin', res)
        if (res.code !== 0) {
          return
        }
        this.isShowLogoutDialog = false
        document.cookie =
          'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        this.loginsucess = false
        this.$router.replace('series')
      })
    },

    goToPersonPage () {
      this.$router.replace('person')
    },
    // 退出登录
    logOut (loginsucess) {
      if (loginsucess) {
        // 点击退出
        console.log('退出登录')
        this.isShowLogoutDialog = true
      } else {
        // 点击登录
        this.$router.push('login')
      }
    },
    checkCookie () {
      const token = this.getCookie('authToken')
      if (!token) {
        // 如果 Cookie 不存在或已过期
        this.loginsucess = false
      } else {
        this.loginsucess = true
      }
    },

    getCookie (name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
      return null
    },

    isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  },
  watch: {
    $route (to, from) {
      this.path = this.$route.path
      if (this.path === '/post') {
        this.path_post = true
        this.select = 'recruit'
      } else {
        this.select = this.$route.path.split('/')[1]
      }
    }
  }
}
</script>
<style lang="less">
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  // overflow: hidden;
  // min-width: 1400px;
  // min-width: 980px;
  font-family: "PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", "Heiti SC",
    "WenQuanYi Micro Hei", sans-serif;
}
#app {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.top-head {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  z-index: 110;
  padding: 5px;
  border-radius: 20px;

  .user-info {
    margin-right: 10px;
    font-size: 14px;
    color: #000; /* Color to indicate clickable text */
    cursor: pointer;
    transition: color 0.3s ease;
    white-space: nowrap;
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    // &:hover {
    //   color: blue; /* Darker shade on hover */
    // }
  }
  .blue {
    background-color: blue;
  }
  .red {
    background-color: #dc3545;
  }

  .logout-button {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    cursor: pointer;
    width: 90px;
    transition: background-color 0.3s ease;
    &.hover {
      background-color: red;
    }
  }
  .login-button {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    color: white;
    font-size: 14px;
    width: 90px;

    cursor: pointer;
    transition: background-color 0.3s ease;
    &.hover {
      background-color: #007bff;
    }
  }
}
.title_top {
  position: absolute;
  top: 30px;
  width: 100%;
  margin: 0 auto;
  .logo {
    position: absolute;
    width: 100px;
    left: 30px;
    z-index: 99;
    top: 0;
    img {
      width: 100px;
    }
  }
  .title_hei {
    height: 40px;
  }
  .m-tabbar {
    position: absolute;
    z-index: 99;
    .m-tabbar-item {
      margin-left: 48px;
      .m-tabbar-item-icon {
        display: block;
        padding-top: 2px;
        img {
          height: 28px;
        }
      }
    }
  }
}
.dot_box {
  width: 20px;
  height: 200px;
  position: fixed;
  right: 30px;
  // top: 350px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
  li {
    width: 8px;
    height: 8px;
    display: block;
    background-color: #cccccc;
    border-radius: 50%;
    margin-top: 20px;
  }
  .about_dot {
    background-color: #313640;
  }
  .home_click {
    border: 4px solid #252525;
    margin-left: -4px;
  }
  .about_click {
    border: 4px solid #cccccc;
    margin-left: -4px;
  }
}
.myMessage {
  position: fixed;
  bottom: 0;
  z-index: 99999999;
  color: #000;
}

.component-fade-enter-active {
  transition: opacity 1s;
}
.component-fade-enter {
  opacity: 0;
}
.component-fade-enter-to {
  opacity: 1;
}
@import "../static/Adaptive/App.less";
</style>



// WEBPACK FOOTER //
// src/App.vue